module.exports = __webpack_public_path__ + "static/img/6.b7dbae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/6.png
// module id = 820l
// module chunks = 0